import React from "react";
import { MapConfig } from "../types";
import { UI_CONFIG } from "../constants";

interface MapSelectorProps {
  selectedMap: string;
  availableMaps: MapConfig[];
  onSelectMap: (mapSrc: string) => void;
}

/**
 * マップ選択ドロップダウンコンポーネント
 */
const MapSelector: React.FC<MapSelectorProps> = ({
  selectedMap,
  availableMaps,
  onSelectMap,
}) => {
  return (
    <select
      value={selectedMap}
      onChange={(e) => onSelectMap(e.target.value)}
      className="border rounded p-1"
      style={{
        position: "absolute",
        left: 8,
        zIndex: UI_CONFIG.Z_INDEX_CONTROLS,
      }}
    >
      {availableMaps.map((map) => (
        <option key={map.src} value={map.src}>
          {map.name}
        </option>
      ))}
    </select>
  );
};

export default MapSelector;
